module.exports = __webpack_public_path__ + "static/media/Risorsa 09.0a0f1697.svg";